class CustomModal extends HTMLElement {
    constructor() {
      super();
      // Event handler bindings
      this._onModalCloseClick = this._onModalCloseClick.bind(this);
      this._onKeyUp = this._onKeyUp.bind(this);
      this._onKeyDown = this._onKeyDown.bind(this);
      this._onPointerUp = this._onPointerUp.bind(this);
      this._onClick = this._onClick.bind(this);
      this.getFocusableElements = this.getFocusableElements.bind(this);
    }
  
    connectedCallback() {
      if (!this.moved) {
        this.moved = true;
        document.body.appendChild(this);
      }
  
      // Add event listeners
      const modalCloseButton = this.querySelector('[id^="ModalClose-"]');
      if (modalCloseButton) {
        modalCloseButton.addEventListener("click", this._onModalCloseClick);
      }
  
      this.addEventListener("keyup", this._onKeyUp);
      this.addEventListener("keydown", this._onKeyDown);
  
      if (this.classList.contains("media-modal")) {
        this.addEventListener("pointerup", this._onPointerUp);
      } else {
        this.addEventListener("click", this._onClick);
      }
    }
  
    disconnectedCallback() {
      // Remove event listeners
      const modalCloseButton = this.querySelector('[id^="ModalClose-"]');
      if (modalCloseButton) {
        modalCloseButton.removeEventListener("click", this._onModalCloseClick);
      }
  
      this.removeEventListener("keyup", this._onKeyUp);
      this.removeEventListener("keydown", this._onKeyDown);
  
      if (this.classList.contains("media-modal")) {
        this.removeEventListener("pointerup", this._onPointerUp);
      } else {
        this.removeEventListener("click", this._onClick);
      }
    }
  
    temporaryHideFocusVisible() {
      document.body.classList.add("no-focus-visible");
    }
  
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector(".template-popup");
      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      if (popup) popup.loadContent();
  
      // Focus management
      const modalCloseButton = this.querySelector('[id^="ModalClose-"]');
      if (modalCloseButton) {
        modalCloseButton.setAttribute("tabindex", "0");
        modalCloseButton.focus();
  
        this.temporaryHideFocusVisible();
      }
  
      // Update tabindex of focusable elements inside modal
      const { focusableElements } = this.getFocusableElements();
      focusableElements.forEach((el) => el.setAttribute("tabindex", "0"));
  
      window.pauseAllMedia?.();
    }
  
    hide() {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      this.removeAttribute("open");
  
      // Focus management
      if (this.openedBy && typeof this.openedBy.focus === "function") {
        this.openedBy.focus();
  
        this.temporaryHideFocusVisible();
      }
      this.openedBy = null;
  
      // Reset tabindex of focusable elements inside modal
      const { focusableElements } = this.getFocusableElements();
      focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));
  
      window.pauseAllMedia?.();
    }
  
    getFocusableElements() {
      const focusableElementsSelector =
        'button, [href], [role="button"], a, input, select, textarea';
      const focusableElements = Array.from(
        this.querySelectorAll(focusableElementsSelector),
      ).filter(
        (el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden"),
        // && el.tabIndex >= 0,
      );
  
      return {
        focusableElements,
        first: focusableElements[0],
        last: focusableElements[focusableElements.length - 1],
      };
    }
  
    // Event handler methods
    _onModalCloseClick(event) {
      this.hide(false);
    }
  
    _onKeyUp(event) {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    }
  
    _onKeyDown(event) {
      const isTabPressed =
        event.key === "Tab" || event.keyCode === 9 || event.code === "Tab";
      const { first, last } = this.getFocusableElements();
  
      if (
        event.key === "Escape" ||
        event.keyCode === 27 ||
        event.code === "Escape"
      ) {
        this.hide();
      }
  
      if (isTabPressed) {
        if (event.shiftKey) {
          if (
            document.activeElement === first ||
            document.activeElement === this
          ) {
            event.preventDefault();
            last.focus();
          }
        } else if (document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  
    _onPointerUp(event) {
      if (
        event.pointerType === "mouse" &&
        !event.target.closest("deferred-media, product-model")
      ) {
        this.hide();
      }
    }
  
    _onClick(event) {
      if (event.target === this) {
        this.hide();
      }
    }
  }
  customElements.define("custom-modal", CustomModal);


  class PrivateStylingForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector("form");
      this.submitButton = this.querySelector("button[type='submit']");
      this.form.addEventListener("submit", this.onSubmit.bind(this));
      this.form.addEventListener("change", this.onChange.bind(this));
    }

    onSubmit(event) {
      event.preventDefault();

      const formData = new FormData(event.target);
      const modalProductURL = formData.get("modal_product");

      window.location.href = modalProductURL;
    }

    onChange(event) {
      if(this.submitButton.hasAttribute("disabled")) {
        this.submitButton.removeAttribute("disabled");
      }
    }
  }
  customElements.define("private-styling-form", PrivateStylingForm);